var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"treatment-schedule-dot"},[_c('div',{staticClass:"dot",style:({ backgroundColor: _vm.color })}),_c('div',{staticClass:"shadow",style:({ backgroundColor: _vm.color })})])
}
var staticRenderFns = []

export { render, staticRenderFns }